import React from 'react'
import { Tooltip } from 'antd'

export const DashboardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13H3C2.73478 13 2.48043 13.1054 2.29289 13.2929C2.10536 13.4804 2 13.7348 2 14V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13ZM9 20H4V15H9V20ZM21 2H14C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM20 9H15V4H20V9ZM21 13H14C13.7348 13 13.4804 13.1054 13.2929 13.2929C13.1054 13.4804 13 13.7348 13 14V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V14C22 13.7348 21.8946 13.4804 21.7071 13.2929C21.5196 13.1054 21.2652 13 21 13ZM20 20H15V15H20V20ZM10 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2ZM9 9H4V4H9V9Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const JobsIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 3H14V2C14 1.46957 13.7893 0.960859 13.4142 0.585786C13.0391 0.210714 12.5304 0 12 0H8C7.46957 0 6.96086 0.210714 6.58579 0.585786C6.21071 0.960859 6 1.46957 6 2V3H3C2.20435 3 1.44129 3.31607 0.87868 3.87868C0.316071 4.44129 0 5.20435 0 6V15C0 15.7956 0.316071 16.5587 0.87868 17.1213C1.44129 17.6839 2.20435 18 3 18H17C17.7956 18 18.5587 17.6839 19.1213 17.1213C19.6839 16.5587 20 15.7956 20 15V6C20 5.20435 19.6839 4.44129 19.1213 3.87868C18.5587 3.31607 17.7956 3 17 3ZM8 2H12V3H8V2ZM18 15C18 15.2652 17.8946 15.5196 17.7071 15.7071C17.5196 15.8946 17.2652 16 17 16H3C2.73478 16 2.48043 15.8946 2.29289 15.7071C2.10536 15.5196 2 15.2652 2 15V9.39L6.68 11C6.78618 11.0144 6.89382 11.0144 7 11H13C13.1084 10.998 13.2161 10.9812 13.32 10.95L18 9.39V15ZM18 7.28L12.84 9H7.16L2 7.28V6C2 5.73478 2.10536 5.48043 2.29289 5.29289C2.48043 5.10536 2.73478 5 3 5H17C17.2652 5 17.5196 5.10536 17.7071 5.29289C17.8946 5.48043 18 5.73478 18 6V7.28Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const ResumeIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H8V5C8 5.79565 8.31607 6.55871 8.87868 7.12132C9.44129 7.68393 10.2044 8 11 8H14V9C14 9.26522 14.1054 9.51957 14.2929 9.70711C14.4804 9.89464 14.7348 10 15 10C15.2652 10 15.5196 9.89464 15.7071 9.70711C15.8946 9.51957 16 9.26522 16 9V7V6.94C15.9896 6.84813 15.9695 6.75763 15.94 6.67V6.58C15.8919 6.47718 15.8278 6.38267 15.75 6.3L9.75 0.3C9.66734 0.222216 9.57282 0.158081 9.47 0.11C9.44015 0.10576 9.40985 0.10576 9.38 0.11C9.27841 0.0517412 9.16622 0.0143442 9.05 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H10C10.2652 20 10.5196 19.8946 10.7071 19.7071C10.8946 19.5196 11 19.2652 11 19C11 18.7348 10.8946 18.4804 10.7071 18.2929C10.5196 18.1054 10.2652 18 10 18ZM10 3.41L12.59 6H11C10.7348 6 10.4804 5.89464 10.2929 5.70711C10.1054 5.51957 10 5.26522 10 5V3.41ZM5 6C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7C4 7.26522 4.10536 7.51957 4.29289 7.70711C4.48043 7.89464 4.73478 8 5 8H6C6.26522 8 6.51957 7.89464 6.70711 7.70711C6.89464 7.51957 7 7.26522 7 7C7 6.73478 6.89464 6.48043 6.70711 6.29289C6.51957 6.10536 6.26522 6 6 6H5ZM19.71 18.29L18.54 17.13C18.914 16.4773 19.0636 15.7199 18.9661 14.974C18.8686 14.2281 18.5292 13.5347 18 13C17.513 12.4957 16.8854 12.1497 16.199 12.0071C15.5126 11.8646 14.7992 11.9321 14.1517 12.2008C13.5041 12.4695 12.9526 12.927 12.5688 13.5137C12.185 14.1004 11.9868 14.7891 12 15.49C11.9966 16.0932 12.1509 16.6868 12.4476 17.2119C12.7444 17.7371 13.1733 18.1755 13.6917 18.4838C14.2102 18.7921 14.8003 18.9594 15.4034 18.9693C16.0065 18.9791 16.6017 18.8311 17.13 18.54L18.29 19.71C18.383 19.8037 18.4936 19.8781 18.6154 19.9289C18.7373 19.9797 18.868 20.0058 19 20.0058C19.132 20.0058 19.2627 19.9797 19.3846 19.9289C19.5064 19.8781 19.617 19.8037 19.71 19.71C19.8037 19.617 19.8781 19.5064 19.9289 19.3846C19.9797 19.2627 20.0058 19.132 20.0058 19C20.0058 18.868 19.9797 18.7373 19.9289 18.6154C19.8781 18.4936 19.8037 18.383 19.71 18.29ZM16.54 16.54C16.2544 16.8086 15.8771 16.9581 15.485 16.9581C15.0929 16.9581 14.7156 16.8086 14.43 16.54C14.1547 16.2598 14.0003 15.8828 14 15.49C13.9979 15.2928 14.0359 15.0971 14.1115 14.915C14.1871 14.7328 14.2989 14.5678 14.44 14.43C14.7066 14.1648 15.0641 14.0111 15.44 14C15.6422 13.9876 15.8447 14.0171 16.035 14.0866C16.2252 14.1562 16.399 14.2643 16.5455 14.4042C16.692 14.5441 16.808 14.7128 16.8862 14.8996C16.9644 15.0865 17.0031 15.2875 17 15.49C16.9917 15.8871 16.8263 16.2647 16.54 16.54ZM11 10H5C4.73478 10 4.48043 10.1054 4.29289 10.2929C4.10536 10.4804 4 10.7348 4 11C4 11.2652 4.10536 11.5196 4.29289 11.7071C4.48043 11.8946 4.73478 12 5 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10ZM9 16C9.26522 16 9.51957 15.8946 9.70711 15.7071C9.89464 15.5196 10 15.2652 10 15C10 14.7348 9.89464 14.4804 9.70711 14.2929C9.51957 14.1054 9.26522 14 9 14H5C4.73478 14 4.48043 14.1054 4.29289 14.2929C4.10536 14.4804 4 14.7348 4 15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H9Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const NamedUserIcon = () => {
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3 8.72C11.8336 8.25813 12.2616 7.68688 12.5549 7.04502C12.8482 6.40316 13 5.70571 13 5C13 3.67392 12.4732 2.40215 11.5355 1.46447C10.5979 0.526784 9.32608 1.78911e-07 8 1.78911e-07C6.67392 1.78911e-07 5.40215 0.526784 4.46447 1.46447C3.52678 2.40215 3 3.67392 3 5C2.99999 5.70571 3.1518 6.40316 3.44513 7.04502C3.73845 7.68688 4.16642 8.25813 4.7 8.72C3.30014 9.35388 2.11247 10.3775 1.27898 11.6685C0.445495 12.9596 0.00147185 14.4633 0 16C0 16.2652 0.105357 16.5196 0.292893 16.7071C0.48043 16.8946 0.734784 17 1 17C1.26522 17 1.51957 16.8946 1.70711 16.7071C1.89464 16.5196 2 16.2652 2 16C2 14.4087 2.63214 12.8826 3.75736 11.7574C4.88258 10.6321 6.4087 10 8 10C9.5913 10 11.1174 10.6321 12.2426 11.7574C13.3679 12.8826 14 14.4087 14 16C14 16.2652 14.1054 16.5196 14.2929 16.7071C14.4804 16.8946 14.7348 17 15 17C15.2652 17 15.5196 16.8946 15.7071 16.7071C15.8946 16.5196 16 16.2652 16 16C15.9985 14.4633 15.5545 12.9596 14.721 11.6685C13.8875 10.3775 12.6999 9.35388 11.3 8.72ZM8 8C7.40666 8 6.82664 7.82405 6.33329 7.49441C5.83994 7.16476 5.45542 6.69623 5.22836 6.14805C5.0013 5.59987 4.94189 4.99667 5.05764 4.41473C5.1734 3.83279 5.45912 3.29824 5.87868 2.87868C6.29824 2.45912 6.83279 2.1734 7.41473 2.05764C7.99667 1.94189 8.59987 2.0013 9.14805 2.22836C9.69623 2.45542 10.1648 2.83994 10.4944 3.33329C10.8241 3.82664 11 4.40666 11 5C11 5.79565 10.6839 6.55871 10.1213 7.12132C9.55871 7.68393 8.79565 8 8 8ZM17.74 8.32C18.38 7.59933 18.798 6.70905 18.9438 5.75634C19.0896 4.80362 18.9569 3.82907 18.5618 2.95C18.1666 2.07093 17.5258 1.3248 16.7165 0.801423C15.9071 0.27805 14.9638 -0.0002576 14 1.78911e-07C13.7348 1.78911e-07 13.4804 0.105357 13.2929 0.292893C13.1054 0.48043 13 0.734784 13 1C13 1.26522 13.1054 1.51957 13.2929 1.70711C13.4804 1.89464 13.7348 2 14 2C14.7956 2 15.5587 2.31607 16.1213 2.87868C16.6839 3.44129 17 4.20435 17 5C16.9986 5.52524 16.8593 6.0409 16.5961 6.49542C16.3328 6.94994 15.9549 7.32738 15.5 7.59C15.3517 7.67552 15.2279 7.79766 15.1404 7.94474C15.0528 8.09182 15.0045 8.2589 15 8.43C14.9958 8.59976 15.0349 8.7678 15.1137 8.91826C15.1924 9.06872 15.3081 9.19665 15.45 9.29L15.84 9.55L15.97 9.62C17.1754 10.1917 18.1923 11.096 18.901 12.2263C19.6096 13.3566 19.9805 14.6659 19.97 16C19.97 16.2652 20.0754 16.5196 20.2629 16.7071C20.4504 16.8946 20.7048 17 20.97 17C21.2352 17 21.4896 16.8946 21.6771 16.7071C21.8646 16.5196 21.97 16.2652 21.97 16C21.9782 14.4654 21.5938 12.9543 20.8535 11.6101C20.1131 10.2659 19.0413 9.13331 17.74 8.32Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const CompanyProfileIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.98101 0C8.04148 0.00368503 6.14489 0.571311 4.52223 1.63374C2.89958 2.69617 1.6209 4.20754 0.841947 5.98377C0.0629925 7.76 -0.182618 9.72442 0.135032 11.6378C0.452682 13.5511 1.31988 15.3308 2.63101 16.76C3.56743 17.775 4.70395 18.5851 5.96894 19.1392C7.23394 19.6933 8.59999 19.9793 9.98101 19.9793C11.362 19.9793 12.7281 19.6933 13.9931 19.1392C15.2581 18.5851 16.3946 17.775 17.331 16.76C18.6421 15.3308 19.5093 13.5511 19.827 11.6378C20.1446 9.72442 19.899 7.76 19.1201 5.98377C18.3411 4.20754 17.0624 2.69617 15.4398 1.63374C13.8171 0.571311 11.9205 0.00368503 9.98101 0ZM9.98101 18C7.90947 17.9969 5.91992 17.1903 4.43101 15.75C4.88305 14.6495 5.65204 13.7083 6.64026 13.0459C7.62848 12.3835 8.79132 12.0298 9.98101 12.0298C11.1707 12.0298 12.3335 12.3835 13.3218 13.0459C14.31 13.7083 15.079 14.6495 15.531 15.75C14.0421 17.1903 12.0525 17.9969 9.98101 18ZM7.98101 8C7.98101 7.60444 8.0983 7.21776 8.31807 6.88886C8.53783 6.55996 8.85019 6.30362 9.21564 6.15224C9.58109 6.00087 9.98322 5.96126 10.3712 6.03843C10.7591 6.1156 11.1155 6.30608 11.3952 6.58579C11.6749 6.86549 11.8654 7.22186 11.9426 7.60982C12.0197 7.99778 11.9801 8.39991 11.8288 8.76537C11.6774 9.13082 11.421 9.44318 11.0921 9.66294C10.7632 9.8827 10.3766 10 9.98101 10C9.45057 10 8.94186 9.78929 8.56679 9.41421C8.19172 9.03914 7.98101 8.53043 7.98101 8ZM16.891 14C15.9975 12.4718 14.6224 11.283 12.981 10.62C13.4902 10.0427 13.8219 9.33066 13.9365 8.56944C14.051 7.80822 13.9435 7.03011 13.6268 6.3285C13.31 5.62688 12.7976 5.03156 12.1509 4.61397C11.5042 4.19637 10.7508 3.97425 9.98101 3.97425C9.21122 3.97425 8.45778 4.19637 7.8111 4.61397C7.16442 5.03156 6.65198 5.62688 6.33526 6.3285C6.01853 7.03011 5.91099 7.80822 6.02554 8.56944C6.14008 9.33066 6.47184 10.0427 6.98101 10.62C5.3396 11.283 3.96447 12.4718 3.07101 14C2.35895 12.7871 1.98273 11.4065 1.98101 10C1.98101 7.87827 2.82386 5.84344 4.32415 4.34315C5.82444 2.84285 7.85927 2 9.98101 2C12.1027 2 14.1376 2.84285 15.6379 4.34315C17.1382 5.84344 17.981 7.87827 17.981 10C17.9793 11.4065 17.6031 12.7871 16.891 14Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const DashboardSettingsIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9009 11.6594C18.7406 11.4769 18.6521 11.2423 18.6521 10.9994C18.6521 10.7565 18.7406 10.5219 18.9009 10.3394L20.1809 8.89941C20.3219 8.74208 20.4095 8.54411 20.4311 8.33391C20.4526 8.12372 20.407 7.91209 20.3009 7.72941L18.3009 4.26941C18.1958 4.08693 18.0358 3.94228 17.8436 3.85609C17.6515 3.7699 17.437 3.74656 17.2309 3.78941L15.3509 4.16941C15.1117 4.21884 14.8626 4.179 14.6508 4.05741C14.4389 3.93582 14.2789 3.74089 14.2009 3.50941L13.5909 1.67941C13.5238 1.48079 13.396 1.30827 13.2255 1.18625C13.055 1.06423 12.8505 0.998866 12.6409 0.999407H8.64087C8.42281 0.988025 8.20701 1.04833 8.02644 1.17112C7.84587 1.29391 7.71045 1.47243 7.64087 1.67941L7.08087 3.50941C7.00287 3.74089 6.84284 3.93582 6.63099 4.05741C6.41913 4.179 6.17009 4.21884 5.93087 4.16941L4.00087 3.78941C3.80542 3.76179 3.60617 3.79263 3.42822 3.87805C3.25027 3.96346 3.10157 4.09964 3.00087 4.26941L1.00087 7.72941C0.892033 7.91006 0.843095 8.12049 0.861055 8.33063C0.879016 8.54077 0.962955 8.73985 1.10087 8.89941L2.37087 10.3394C2.53119 10.5219 2.61961 10.7565 2.61961 10.9994C2.61961 11.2423 2.53119 11.4769 2.37087 11.6594L1.10087 13.0994C0.962955 13.259 0.879016 13.458 0.861055 13.6682C0.843095 13.8783 0.892033 14.0888 1.00087 14.2694L3.00087 17.7294C3.10597 17.9119 3.26599 18.0565 3.45812 18.1427C3.65026 18.2289 3.8647 18.2522 4.07087 18.2094L5.95087 17.8294C6.19009 17.78 6.43913 17.8198 6.65099 17.9414C6.86284 18.063 7.02287 18.2579 7.10087 18.4894L7.71087 20.3194C7.78045 20.5264 7.91587 20.7049 8.09644 20.8277C8.27701 20.9505 8.49281 21.0108 8.71087 20.9994H12.7109C12.9205 20.9999 13.125 20.9346 13.2955 20.8126C13.466 20.6905 13.5938 20.518 13.6609 20.3194L14.2709 18.4894C14.3489 18.2579 14.5089 18.063 14.7208 17.9414C14.9326 17.8198 15.1817 17.78 15.4209 17.8294L17.3009 18.2094C17.507 18.2522 17.7215 18.2289 17.9136 18.1427C18.1058 18.0565 18.2658 17.9119 18.3709 17.7294L20.3709 14.2694C20.477 14.0867 20.5226 13.8751 20.5011 13.6649C20.4795 13.4547 20.3919 13.2567 20.2509 13.0994L18.9009 11.6594ZM17.4109 12.9994L18.2109 13.8994L16.9309 16.1194L15.7509 15.8794C15.0307 15.7322 14.2814 15.8545 13.6455 16.2232C13.0095 16.5919 12.531 17.1812 12.3009 17.8794L11.9209 18.9994H9.36087L9.00087 17.8594C8.77073 17.1612 8.29225 16.5719 7.65628 16.2032C7.0203 15.8345 6.27109 15.7122 5.55087 15.8594L4.37087 16.0994L3.07087 13.8894L3.87087 12.9894C4.36283 12.4394 4.6348 11.7273 4.6348 10.9894C4.6348 10.2515 4.36283 9.53943 3.87087 8.98941L3.07087 8.08941L4.35087 5.88941L5.53087 6.12941C6.25109 6.27663 7.0003 6.15429 7.63628 5.78561C8.27225 5.41692 8.75073 4.82757 8.98087 4.12941L9.36087 2.99941H11.9209L12.3009 4.13941C12.531 4.83757 13.0095 5.42692 13.6455 5.79561C14.2814 6.16429 15.0307 6.28663 15.7509 6.13941L16.9309 5.89941L18.2109 8.11941L17.4109 9.01941C16.9244 9.56817 16.6558 10.2761 16.6558 11.0094C16.6558 11.7427 16.9244 12.4506 17.4109 12.9994ZM10.6409 6.99941C9.84975 6.99941 9.07639 7.234 8.41859 7.67353C7.76079 8.11305 7.24811 8.73777 6.94535 9.46867C6.6426 10.1996 6.56339 11.0038 6.71773 11.7798C6.87207 12.5557 7.25304 13.2684 7.81245 13.8278C8.37186 14.3872 9.08459 14.7682 9.86051 14.9225C10.6364 15.0769 11.4407 14.9977 12.1716 14.6949C12.9025 14.3922 13.5272 13.8795 13.9668 13.2217C14.4063 12.5639 14.6409 11.7905 14.6409 10.9994C14.6409 9.93854 14.2194 8.92112 13.4693 8.17098C12.7192 7.42083 11.7017 6.99941 10.6409 6.99941ZM10.6409 12.9994C10.2453 12.9994 9.85863 12.8821 9.52973 12.6623C9.20083 12.4426 8.94449 12.1302 8.79311 11.7648C8.64174 11.3993 8.60213 10.9972 8.6793 10.6092C8.75647 10.2213 8.94695 9.8649 9.22666 9.58519C9.50636 9.30549 9.86273 9.11501 10.2507 9.03784C10.6387 8.96067 11.0408 9.00027 11.4062 9.15165C11.7717 9.30302 12.084 9.55937 12.3038 9.88827C12.5236 10.2172 12.6409 10.6038 12.6409 10.9994C12.6409 11.5298 12.4302 12.0385 12.0551 12.4136C11.68 12.7887 11.1713 12.9994 10.6409 12.9994Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const CloseModalIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <path
        d="M9.50084 0.50084C9.36019 0.360237 9.16946 0.28125 8.97059 0.28125C8.77172 0.28125 8.58099 0.360237 8.44034 0.50084L5.00084 3.94034L1.56134 0.50084C1.42069 0.360237 1.22996 0.28125 1.03109 0.28125C0.832217 0.28125 0.641486 0.360237 0.50084 0.50084C0.360237 0.641486 0.28125 0.832217 0.28125 1.03109C0.28125 1.22996 0.360237 1.42069 0.50084 1.56134L3.94034 5.00084L0.50084 8.44034C0.360237 8.58099 0.28125 8.77172 0.28125 8.97059C0.28125 9.16946 0.360237 9.36019 0.50084 9.50084C0.641486 9.64144 0.832217 9.72043 1.03109 9.72043C1.22996 9.72043 1.42069 9.64144 1.56134 9.50084L5.00084 6.06134L8.44034 9.50084C8.58099 9.64144 8.77172 9.72043 8.97059 9.72043C9.16946 9.72043 9.36019 9.64144 9.50084 9.50084C9.64144 9.36019 9.72043 9.16946 9.72043 8.97059C9.72043 8.77172 9.64144 8.58099 9.50084 8.44034L6.06134 5.00084L9.50084 1.56134C9.64144 1.42069 9.72043 1.22996 9.72043 1.03109C9.72043 0.832217 9.64144 0.641486 9.50084 0.50084Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="9"
      viewBox="0 0 16 9"
      fill="none"
    >
      <path
        d="M14.0002 8.00078C13.8686 8.00154 13.7381 7.97632 13.6163 7.92655C13.4944 7.87679 13.3836 7.80346 13.2902 7.71078L8.71019 3.12079C8.61722 3.02706 8.50662 2.95267 8.38476 2.9019C8.2629 2.85113 8.1322 2.82499 8.00019 2.82499C7.86817 2.82499 7.73747 2.85113 7.61561 2.9019C7.49375 2.95267 7.38315 3.02706 7.29019 3.12079L2.71019 7.71078C2.52188 7.89909 2.26649 8.00487 2.00019 8.00487C1.73388 8.00487 1.47849 7.89909 1.29019 7.71078C1.10188 7.52248 0.996094 7.26708 0.996094 7.00078C0.996094 6.86892 1.02207 6.73836 1.07253 6.61653C1.12299 6.49471 1.19695 6.38402 1.29019 6.29078L5.88019 1.71079C6.45013 1.16323 7.20983 0.857422 8.00019 0.857422C8.79054 0.857422 9.55024 1.16323 10.1202 1.71079L14.7102 6.29078C14.8039 6.38375 14.8783 6.49435 14.9291 6.61621C14.9798 6.73807 15.006 6.86877 15.006 7.00078C15.006 7.13279 14.9798 7.2635 14.9291 7.38536C14.8783 7.50722 14.8039 7.61782 14.7102 7.71078C14.6167 7.80346 14.5059 7.87679 14.3841 7.92655C14.2623 7.97632 14.1318 8.00154 14.0002 8.00078Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_1434_1528"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2H21.4768V21.477H2V2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1434_1528)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.739 3.5C7.196 3.5 3.5 7.195 3.5 11.738C3.5 16.281 7.196 19.977 11.739 19.977C16.281 19.977 19.977 16.281 19.977 11.738C19.977 7.195 16.281 3.5 11.739 3.5ZM11.739 21.477C6.369 21.477 2 17.108 2 11.738C2 6.368 6.369 2 11.739 2C17.109 2 21.477 6.368 21.477 11.738C21.477 17.108 17.109 21.477 11.739 21.477Z"
          fill="currentColor"
        />
      </g>
      <mask
        id="mask1_1434_1528"
        maskUnits="userSpaceOnUse"
        x="17"
        y="17"
        width="6"
        height="6"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.2397 17.7069H22.2638V22.7217H17.2397V17.7069Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1434_1528)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.514 22.7217C21.323 22.7217 21.131 22.6487 20.984 22.5027L17.46 18.9887C17.167 18.6957 17.166 18.2207 17.459 17.9277C17.751 17.6327 18.226 17.6347 18.52 17.9257L22.044 21.4407C22.337 21.7337 22.338 22.2077 22.045 22.5007C21.899 22.6487 21.706 22.7217 21.514 22.7217Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
export const EnvelopIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="21"
      viewBox="0 0 29 21"
      fill="none"
    >
      <path
        d="M26.125 0.8125H2.875C2.36114 0.8125 1.86833 1.01663 1.50498 1.37998C1.14163 1.74333 0.9375 2.23614 0.9375 2.75V18.25C0.9375 18.7639 1.14163 19.2567 1.50498 19.62C1.86833 19.9834 2.36114 20.1875 2.875 20.1875H26.125C26.6389 20.1875 27.1317 19.9834 27.495 19.62C27.8584 19.2567 28.0625 18.7639 28.0625 18.25V2.75C28.0625 2.23614 27.8584 1.74333 27.495 1.37998C27.1317 1.01663 26.6389 0.8125 26.125 0.8125ZM23.9937 2.75L14.5 9.31812L5.00625 2.75H23.9937ZM2.875 18.25V3.63156L13.9478 11.2944C14.11 11.4069 14.3026 11.4672 14.5 11.4672C14.6974 11.4672 14.89 11.4069 15.0522 11.2944L26.125 3.63156V18.25H2.875Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const BackArrowIcon = () => {
  return (
    <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512">
      <g fill="currentColor">
        <g fill="currentColor">
          <path
            fill="currentColor"
            d="M395.5,236H164.9l70.2-69.8c7.8-7.8,7.9-20.5,0.1-28.3c-7.8-7.8-20.5-7.9-28.3-0.1l-104.5,104c0,0,0,0,0,0
			c-7.8,7.8-7.8,20.5,0,28.3c0,0,0,0,0,0l104.5,104c7.8,7.8,20.5,7.8,28.3-0.1c7.8-7.8,7.8-20.5-0.1-28.3L164.9,276h230.6
			c11,0,20-9,20-20C415.5,245,406.5,236,395.5,236z"
          />
        </g>
      </g>
    </svg>
  )
}
export const MinusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
    >
      <path d="M0.75 0.25H11.25V1.75H0.75V0.25Z" fill="#232323" />
    </svg>
  )
}

export const PlusIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M5.25 5.25V0.75H6.75V5.25H11.25V6.75H6.75V11.25H5.25V6.75H0.75V5.25H5.25Z"
        fill="#232323"
      />
    </svg>
  )
}
export const StepCheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
    >
      <path
        d="M1 3L3.16744 5.66667L9 1"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const BookMarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="22"
      viewBox="0 0 17 22"
      fill="none"
    >
      <path
        d="M2.25 2.125V19.1875L7.03594 15.3578C7.4515 15.0254 7.96783 14.8443 8.5 14.8443C9.03217 14.8443 9.5485 15.0254 9.96406 15.3578L14.75 19.1859V2.125H2.25ZM1.46875 0.5625H15.5312C15.7385 0.5625 15.9372 0.64481 16.0837 0.791323C16.2302 0.937836 16.3125 1.13655 16.3125 1.34375V20.8125C16.3123 20.9595 16.2706 21.1035 16.1922 21.2279C16.1139 21.3522 16.002 21.452 15.8695 21.5156C15.737 21.5793 15.5892 21.6042 15.4431 21.5877C15.2971 21.5711 15.1586 21.5136 15.0437 21.4219L8.9875 16.5781C8.84906 16.4676 8.67716 16.4074 8.5 16.4074C8.32284 16.4074 8.15094 16.4676 8.0125 16.5781L1.95625 21.4219C1.84137 21.5136 1.70295 21.5711 1.55688 21.5877C1.41081 21.6042 1.26302 21.5793 1.13051 21.5156C0.997993 21.452 0.886124 21.3522 0.807758 21.2279C0.729392 21.1035 0.687709 20.9595 0.6875 20.8125V1.34375C0.6875 1.13655 0.76981 0.937836 0.916323 0.791323C1.06284 0.64481 1.26155 0.5625 1.46875 0.5625Z"
        fill="black"
      />
    </svg>
  )
}
export const DownloadIcon = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22.000000 17.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,17.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M90 145 c0 -18 -5 -25 -20 -25 -28 0 -25 -11 10 -45 l30 -29 30 29
   c35 34 38 45 10 45 -15 0 -20 7 -20 25 0 18 -5 25 -20 25 -15 0 -20 -7 -20
   -25z"
        />
        <path
          d="M0 20 c0 -19 7 -20 110 -20 103 0 110 1 110 20 0 11 -7 20 -15 20 -8
   0 -15 -4 -15 -10 0 -6 -33 -10 -80 -10 -47 0 -80 4 -80 10 0 6 -7 10 -15 10
   -8 0 -15 -9 -15 -20z"
        />
      </g>
    </svg>
  )
}
export const ShareIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M15.5297 13.3751C14.9917 13.3779 14.4612 13.5013 13.9773 13.7364C13.4934 13.9715 13.0684 14.3123 12.7338 14.7336L7.47975 11.4489C7.67124 10.8309 7.67124 10.1694 7.47975 9.5514L12.7338 6.26671C13.2671 6.92704 14.0169 7.3773 14.8503 7.53775C15.6838 7.6982 16.5472 7.55847 17.2875 7.14331C18.0278 6.72816 18.5973 6.06438 18.895 5.26955C19.1928 4.47472 19.1996 3.60016 18.9143 2.80078C18.629 2.0014 18.07 1.3288 17.3362 0.902125C16.6025 0.475454 15.7414 0.322251 14.9056 0.469657C14.0697 0.617063 13.313 1.05556 12.7694 1.70748C12.2259 2.35939 11.9307 3.18264 11.936 4.0314C11.9394 4.35281 11.9878 4.67216 12.0797 4.98015L6.82569 8.26483C6.36184 7.68091 5.72782 7.25574 5.01153 7.04827C4.29523 6.8408 3.53213 6.86131 2.82801 7.10694C2.12388 7.35257 1.51361 7.81116 1.08179 8.41915C0.64996 9.02714 0.417969 9.75441 0.417969 10.5001C0.417969 11.2459 0.64996 11.9732 1.08179 12.5811C1.51361 13.1891 2.12388 13.6477 2.82801 13.8934C3.53213 14.139 4.29523 14.1595 5.01153 13.952C5.72782 13.7445 6.36184 13.3194 6.82569 12.7355L12.0797 16.0201C11.9878 16.3281 11.9394 16.6475 11.936 16.9689C11.936 17.6797 12.1468 18.3745 12.5417 18.9655C12.9365 19.5565 13.4978 20.0171 14.1545 20.2891C14.8112 20.5611 15.5337 20.6323 16.2309 20.4936C16.928 20.3549 17.5683 20.0127 18.0709 19.5101C18.5735 19.0075 18.9158 18.3671 19.0544 17.67C19.1931 16.9729 19.1219 16.2503 18.8499 15.5936C18.5779 14.937 18.1173 14.3757 17.5263 13.9808C16.9353 13.5859 16.2405 13.3751 15.5297 13.3751ZM15.5297 1.87515C15.9562 1.87515 16.3731 2.00161 16.7277 2.23854C17.0823 2.47547 17.3587 2.81223 17.5219 3.20624C17.6851 3.60024 17.7278 4.03379 17.6446 4.45206C17.5614 4.87033 17.356 5.25454 17.0544 5.5561C16.7529 5.85765 16.3687 6.06302 15.9504 6.14621C15.5321 6.22941 15.0986 6.18671 14.7046 6.02351C14.3106 5.86031 13.9738 5.58394 13.7369 5.22934C13.5 4.87475 13.3735 4.45786 13.3735 4.0314C13.3735 3.45952 13.6007 2.91107 14.005 2.5067C14.4094 2.10232 14.9579 1.87515 15.5297 1.87515ZM4.02975 12.6564C3.60328 12.6564 3.18639 12.5299 2.8318 12.293C2.47721 12.0561 2.20084 11.7193 2.03763 11.3253C1.87443 10.9313 1.83173 10.4978 1.91493 10.0795C1.99813 9.66121 2.20349 9.277 2.50505 8.97545C2.80661 8.67389 3.19081 8.46853 3.60909 8.38533C4.02736 8.30213 4.46091 8.34483 4.85491 8.50803C5.24891 8.67123 5.58567 8.9476 5.82261 9.3022C6.05954 9.65679 6.186 10.0737 6.186 10.5001C6.186 11.072 5.95882 11.6205 5.55445 12.0248C5.15007 12.4292 4.60162 12.6564 4.02975 12.6564ZM15.5297 19.1251C15.1033 19.1251 14.6864 18.9987 14.3318 18.7618C13.9772 18.5248 13.7008 18.1881 13.5376 17.7941C13.3744 17.4001 13.3317 16.9665 13.4149 16.5482C13.4981 16.13 13.7035 15.7458 14.005 15.4442C14.3066 15.1426 14.6908 14.9373 15.1091 14.8541C15.5274 14.7709 15.9609 14.8136 16.3549 14.9768C16.7489 15.14 17.0857 15.4164 17.3226 15.7709C17.5595 16.1255 17.686 16.5424 17.686 16.9689C17.686 17.5408 17.4588 18.0892 17.0544 18.4936C16.6501 18.898 16.1016 19.1251 15.5297 19.1251Z"
        fill="black"
      />
    </svg>
  )
}
export const FaceBookIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.397 20.9969V12.8009H16.162L16.573 9.59193H13.397V7.54792C13.397 6.62192 13.655 5.98793 14.984 5.98793H16.668V3.12693C15.8487 3.03912 15.0251 2.99672 14.201 2.99993C11.757 2.99993 10.079 4.49193 10.079 7.23093V9.58593H7.33203V12.7949H10.085V20.9969H13.397Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const TwitterIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 5.95992C21.0328 6.2693 20.2524 6.49195 19.4485 6.57867C20.2831 6.08282 20.9081 5.29945 21.2063 4.37555C20.4231 4.84146 19.5651 5.16816 18.6703 5.34117C18.2964 4.94139 17.8441 4.62291 17.3417 4.40556C16.8392 4.18822 16.2974 4.07668 15.75 4.07789C13.5352 4.07789 11.7539 5.8732 11.7539 8.07633C11.7539 8.3857 11.7914 8.69508 11.8524 8.99273C8.53596 8.8193 5.57815 7.23492 3.61174 4.80914C3.25344 5.42113 3.06568 6.11795 3.06799 6.82711C3.06799 8.21461 3.77346 9.43805 4.84924 10.1576C4.21527 10.1326 3.59614 9.95836 3.04221 9.64898V9.6982C3.04221 11.6412 4.41565 13.2513 6.24612 13.6216C5.90243 13.7109 5.54887 13.7566 5.19377 13.7576C4.93362 13.7576 4.68752 13.7318 4.43909 13.6966C4.94534 15.281 6.41956 16.4318 8.17502 16.4693C6.80159 17.5451 5.08127 18.1779 3.21331 18.1779C2.87815 18.1779 2.56877 18.1662 2.24768 18.1287C4.01956 19.2654 6.1219 19.9216 8.38596 19.9216C15.736 19.9216 19.7578 13.8326 19.7578 8.54742C19.7578 8.37398 19.7578 8.20055 19.7461 8.02711C20.5242 7.45758 21.2063 6.75211 21.75 5.95992Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const TwitterXIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-twitter-x"
      viewBox="0 0 16 16"
    >
      <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
    </svg>
  )
}

export const LinkedInIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.98304 7.19704C6.19144 7.19704 7.17104 6.21744 7.17104 5.00904C7.17104 3.80065 6.19144 2.82104 4.98304 2.82104C3.77464 2.82104 2.79504 3.80065 2.79504 5.00904C2.79504 6.21744 3.77464 7.19704 4.98304 7.19704Z"
        fill="currentColor"
      />
      <path
        d="M9.23697 8.85493V20.9939H13.006V14.9909C13.006 13.4069 13.304 11.8729 15.268 11.8729C17.205 11.8729 17.229 13.6839 17.229 15.0909V20.9949H21V14.3379C21 11.0679 20.296 8.55493 16.474 8.55493C14.639 8.55493 13.409 9.56193 12.906 10.5149H12.855V8.85493H9.23697ZM3.09497 8.85493H6.86997V20.9939H3.09497V8.85493Z"
        fill="currentColor"
      />
    </svg>
  )
}
export const SearchTwo = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_430_2"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H19.4768V19.477H0V0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_430_2)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.73876 1.5C5.19576 1.5 1.49976 5.195 1.49976 9.738C1.49976 14.281 5.19576 17.977 9.73876 17.977C14.2808 17.977 17.9768 14.281 17.9768 9.738C17.9768 5.195 14.2808 1.5 9.73876 1.5M9.73876 19.477C4.36876 19.477 -0.000244141 15.108 -0.000244141 9.738C-0.000244141 4.368 4.36876 0 9.73876 0C15.1088 0 19.4768 4.368 19.4768 9.738C19.4768 15.108 15.1088 19.477 9.73876 19.477"
          fill="#926874"
        />
      </g>
      <mask
        id="mask1_430_2"
        maskUnits="userSpaceOnUse"
        x="15"
        y="15"
        width="6"
        height="6"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.24 15.7069H20.264V20.7217H15.24V15.7069Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_430_2)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5142 20.7217C19.3232 20.7217 19.1312 20.6487 18.9842 20.5027L15.4602 16.9887C15.1672 16.6957 15.1662 16.2207 15.4592 15.9277C15.7512 15.6327 16.2262 15.6347 16.5202 15.9257L20.0442 19.4407C20.3372 19.7337 20.3382 20.2077 20.0452 20.5007C19.8992 20.6487 19.7062 20.7217 19.5142 20.7217"
          fill="#926874"
        />
      </g>
    </svg>
  )
}
export const LocationIcon = ({ width = 26 }) => {
  return (
    <svg
      width={width}
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2.08923C18.0003 2.08923 22.0536 6.14245 22.0536 11.1428C22.0536 14.9685 19.3653 19.1378 14.0586 23.6952C13.7635 23.9487 13.3873 24.0879 12.9982 24.0876C12.6092 24.0873 12.2333 23.9474 11.9386 23.6934L11.5876 23.3888C6.51577 18.9502 3.94641 14.8831 3.94641 11.1428C3.94641 6.14245 7.99962 2.08923 13 2.08923ZM13 3.48209C10.9682 3.48209 9.0197 4.2892 7.58304 5.72586C6.14638 7.16252 5.33927 9.11106 5.33927 11.1428C5.33927 14.3947 7.70527 18.1414 12.5023 22.3386L12.8486 22.6385C12.8907 22.6747 12.9444 22.6946 13 22.6946C13.0555 22.6946 13.1092 22.6747 13.1513 22.6385C18.1805 18.3188 20.6607 14.4717 20.6607 11.1428C20.6607 10.1368 20.4625 9.14062 20.0776 8.21118C19.6926 7.28174 19.1283 6.43722 18.4169 5.72586C17.7056 5.0145 16.8611 4.45021 15.9316 4.06523C15.0022 3.68024 14.006 3.48209 13 3.48209ZM13 7.66066C13.9235 7.66066 14.8092 8.02753 15.4622 8.68056C16.1153 9.33359 16.4821 10.2193 16.4821 11.1428C16.4821 12.0663 16.1153 12.952 15.4622 13.6051C14.8092 14.2581 13.9235 14.6249 13 14.6249C12.0765 14.6249 11.1908 14.2581 10.5377 13.6051C9.88471 12.952 9.51784 12.0663 9.51784 11.1428C9.51784 10.2193 9.88471 9.33359 10.5377 8.68056C11.1908 8.02753 12.0765 7.66066 13 7.66066ZM13 9.05352C12.4459 9.05352 11.9145 9.27364 11.5226 9.66546C11.1308 10.0573 10.9107 10.5887 10.9107 11.1428C10.9107 11.6969 11.1308 12.2283 11.5226 12.6202C11.9145 13.012 12.4459 13.2321 13 13.2321C13.5541 13.2321 14.0855 13.012 14.4773 12.6202C14.8691 12.2283 15.0893 11.6969 15.0893 11.1428C15.0893 10.5887 14.8691 10.0573 14.4773 9.66546C14.0855 9.27364 13.5541 9.05352 13 9.05352Z"
        fill="#926874"
      />
    </svg>
  )
}
export const BellIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
    >
      <path
        d="M12.75 7.33366C12.75 6.00758 12.1969 4.73581 11.2123 3.79813C10.2277 2.86044 8.89239 2.33366 7.5 2.33366C6.10761 2.33366 4.77226 2.86044 3.78769 3.79813C2.80312 4.73581 2.25 6.00758 2.25 7.33366V14.0003H12.75V7.33366ZM14.5 14.5562L14.85 15.0003C14.8987 15.0622 14.9284 15.1358 14.9357 15.2129C14.943 15.29 14.9276 15.3675 14.8913 15.4367C14.855 15.5059 14.7991 15.5641 14.73 15.6048C14.6609 15.6454 14.5812 15.667 14.5 15.667H0.5C0.418751 15.667 0.339107 15.6454 0.269993 15.6048C0.200878 15.5641 0.145024 15.5059 0.108688 15.4367C0.0723526 15.3675 0.0569714 15.29 0.064268 15.2129C0.0715646 15.1358 0.101251 15.0622 0.15 15.0003L0.5 14.5562V7.33366C0.5 5.56555 1.2375 3.86986 2.55025 2.61961C3.86301 1.36937 5.64348 0.666992 7.5 0.666992C9.35652 0.666992 11.137 1.36937 12.4497 2.61961C13.7625 3.86986 14.5 5.56555 14.5 7.33366V14.5562ZM5.3125 16.5003H9.6875C9.6875 17.0529 9.45703 17.5828 9.0468 17.9735C8.63656 18.3642 8.08016 18.5837 7.5 18.5837C6.91984 18.5837 6.36344 18.3642 5.9532 17.9735C5.54297 17.5828 5.3125 17.0529 5.3125 16.5003Z"
        fill="#09121F"
      />
    </svg>
  )
}
export const AttatchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
    >
      <path
        d="M20.4383 9.11707L11.2483 16.8374C10.1225 17.7832 8.59552 18.3146 7.00333 18.3146C5.41115 18.3146 3.88418 17.7832 2.75834 16.8374C1.63249 15.8916 1 14.6088 1 13.2713C1 11.9337 1.63249 10.6509 2.75834 9.70513L11.9483 1.98477C12.6989 1.35423 13.7169 1 14.7783 1C15.8398 1 16.8578 1.35423 17.6083 1.98477C18.3589 2.6153 18.7805 3.47049 18.7805 4.3622C18.7805 5.25391 18.3589 6.1091 17.6083 6.73963L8.40833 14.46C8.22251 14.6161 8.00191 14.7399 7.75913 14.8244C7.51634 14.9089 7.25612 14.9524 6.99333 14.9524C6.73054 14.9524 6.47033 14.9089 6.22754 14.8244C5.98476 14.7399 5.76415 14.6161 5.57833 14.46C5.39251 14.3039 5.24511 14.1186 5.14455 13.9146C5.04398 13.7106 4.99222 13.492 4.99222 13.2713C4.99222 13.0505 5.04398 12.8319 5.14455 12.6279C5.24511 12.424 5.39251 12.2387 5.57833 12.0826L14.0683 4.95866"
        stroke="#00567C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const RemoveResumeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.49674 8.00013L10.6177 9.97975M6.375 9.97975L8.49674 8.00013L6.375 9.97975ZM10.6177 6.02051L8.49674 8.00013L10.6177 6.02051ZM8.49674 8.00013L6.375 6.02051L8.49674 8.00013Z"
        stroke="#130F26"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 15C12.6422 15 16 11.8661 16 8C16 4.1339 12.6422 1 8.5 1C4.35775 1 1 4.1339 1 8C1 11.8661 4.35775 15 8.5 15Z"
        stroke="#130F26"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const BackIcon = ({ stockColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stockColor}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M15 18l-6-6 6-6" />
    </svg>
  )
}

export const NextIcon = ({ stockColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stockColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 18l6-6-6-6" />
    </svg>
  )
}
export const PrivacyIcon = ({ tooltipText }) => {
  return (
    <Tooltip placement="topLeft" title={tooltipText ? tooltipText : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 22 20"
        fill="none"
        className="ml-1"
      >
        <path
          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Tooltip>
  )
}

export const DiamondIcon = ({ fillColor }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
      aria-hidden="true"
      fill={fillColor}
    >
      <g id="gem1_layer">
        <path
          stroke="#00567C"
          strokeWidth="1.5"
          d="M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"
        ></path>
      </g>
    </svg>
  )
}

export const CalendarIcon = ({ fillColor }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      aria-hidden="true"
      fill={fillColor}
    >
      <g id="calendar-check1_layer">
        <path d="M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"></path>
      </g>
    </svg>
  )
}

export const TimerIcon = ({ fillColor }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      aria-hidden="true"
      fill={fillColor}
    >
      <g id="clock1_layer">
        <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"></path>
      </g>
    </svg>
  )
}

export const ElectronIcon = ({ fillColor }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
      aria-hidden="true"
      fill={fillColor}
    >
      <g id="bolt1_layer">
        <path d="M295.973 160H180.572L215.19 30.184C219.25 14.956 207.756 0 192 0H56C43.971 0 33.8 8.905 32.211 20.828l-31.996 240C-1.704 275.217 9.504 288 24.004 288h118.701L96.646 482.466C93.05 497.649 104.659 512 119.992 512c8.35 0 16.376-4.374 20.778-11.978l175.973-303.997c9.244-15.967-2.288-36.025-20.77-36.025z"></path>
      </g>
    </svg>
  )
}

export const PassIcon = ({ fillColor }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
      aria-hidden="true"
      fill={fillColor}
    >
      <g id="angle-double-right1_layer">
        <path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"></path>
      </g>
    </svg>
  )
}

export const UniversityIcon = ({ fillColor }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      aria-hidden="true"
      fill={fillColor}
    >
      <g id="graduation-cap1_layer">
        <path d="M622.884 199.005l-275.817 85.1a96 96 0 0 1-54.134 0L92.398 222.232c-8.564 11.438-11.018 23.05-11.918 38.335C89.778 266.165 96 276.355 96 288c0 11.952-6.557 22.366-16.265 27.861l16.197 123.096c.63 4.786-3.1 9.043-7.932 9.043H40c-4.828 0-8.562-4.253-7.932-9.044L48.265 315.86C38.557 310.366 32 299.952 32 288c0-12.034 6.646-22.511 16.465-27.976.947-17.951 3.974-33.231 12.152-47.597l-43.502-13.422c-22.876-6.801-22.766-39.241 0-46.01l275.817-85.1a96 96 0 0 1 54.134 0l275.817 85.1c22.877 6.801 22.767 39.241.001 46.01zM356.503 314.682l-.207.064-.207.061a127.998 127.998 0 0 1-72.177 0l-.207-.061-.207-.064-150.914-46.57L120 352c0 35.346 89.543 64 200 64s200-28.654 200-64l-12.583-83.888-150.914 46.57z"></path>
      </g>
    </svg>
  )
}

export const FindIcon = ({ fillColor }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      aria-hidden="true"
      fill={fillColor}
    >
      <g id="search1_layer">
        <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
      </g>
    </svg>
  )
}
